enum EnumPaymentType {
    redirectToECPay = "redirectToECPay" ,
    redirectToNewebPay = "redirectToNewebPay",
    redirect = "redirect",
    refresh = "refresh"
}

export default EnumPaymentType